<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.edl', { value: 'default' })">
      </portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">



        <v-expansion-panels focusable v-model="panel">
          <!-- to confirm doc 
          <v-expansion-panel class="mt-4">
            <v-expansion-panel-header color="#00475A">
              <template v-slot:default>
                <v-row>
                  <v-icon color="orange" left> mdi-file-clock </v-icon>
                  <span class="pt-1">
                    {{ $t("message.extrawork.tovalidate", { value: "default" }) }}
                  </span>
                </v-row>
              </template>

              <template v-slot:actions>
                <v-icon color="#FFFFFF"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table :headers="ccheaders" :items="certificatesToValidate" :search="search"
                class="elevation-0 mt-4" :loading="cloading" dense
                :loading-text="$t('message.loadingText', { value: 'default' })">
                <template v-slot:[`item.leasingStartDate`]="{ item }">
                  {{ getCertificateDate(item) }}
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  {{ filterDocType(item.type) }}
                </template>
                <template v-slot:[`item.id`]="{ item }">
                  {{ item.asset }}
                  <v-icon @click="show(item)"> mdi-eye</v-icon>
                </template>
                <template v-slot:[`item.asset`]="{ item }">
                  <v-icon color="#00475A"> mdi-train</v-icon>
                  {{ item.asset }}
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>-->

          <!-- accepted doc 
          <v-expansion-panel class="mt-4">
            <v-expansion-panel-header color="#00475A">
              <template v-slot:default>
                <v-row>
                  <v-icon color="green" left> mdi-file-certificate </v-icon>
                  <span class="pt-1">
                    {{ $t("message.extrawork.confirm", { value: "default" }) }}
                  </span>
                </v-row>
              </template>

              <template v-slot:actions>
                <v-icon color="#FFFFFF"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>

              <v-data-table :headers="ccheaders" :items="confirmCertificate" :search="search" class="elevation-0 mt-4"
                :loading="cloading" dense :loading-text="$t('message.loadingText', { value: 'default' })">
                <template v-slot:[`item.leasingStartDate`]="{ item }">
                  {{ getCertificateDate(item) }}
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  {{ filterDocType(item.type) }}
                </template>
                <template v-slot:[`item.id`]="{ item }">
                  {{ item.asset }}
                  <v-icon @click="show(item)"> mdi-eye</v-icon>
                </template>
                <template v-slot:[`item.asset`]="{ item }">
                  <v-icon color="#00475A"> mdi-train</v-icon>
                  {{ item.asset }}
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>-->

          <!-- rejected doc 
          <v-expansion-panel class="mt-4">
            <v-expansion-panel-header color="#00475A">
              <template v-slot:default>
                <v-row>
                  <v-icon color="red" left> mdi-file-document-remove </v-icon>
                  <span class="pt-1">
                    {{ $t("message.doc.certificat.reject", { value: "default" }) }}
                  </span>
                </v-row>
              </template>

              <template v-slot:actions>
                <v-icon color="#FFFFFF"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table :headers="ccheaders" :items="rejectCertificate" :search="search" class="elevation-0 mt-4"
                :loading="cloading" dense :loading-text="$t('message.loadingText', { value: 'default' })">
                <template v-slot:[`item.leasingStartDate`]="{ item }">
                  {{ getCertificateDate(item) }}
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  {{ filterDocType(item.type) }}
                </template>
                <template v-slot:[`item.id`]="{ item }">
                  {{ item.asset }}
                  <v-icon @click="show(item)"> mdi-eye</v-icon>
                </template>
                <template v-slot:[`item.asset`]="{ item }">
                  <v-icon color="#00475A"> mdi-train</v-icon>
                  {{ item.asset }}
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
           -->


          <!-- download doc -->
          <v-expansion-panel class="mt-4">
            <v-expansion-panel-header color="#00475A">
              <template v-slot:default>
                <v-row>
                  <v-icon color="info" left> mdi-file-document-remove </v-icon>
                  <span class="pt-1">
                    Download
                  </span>
                </v-row>
              </template>

              <template v-slot:actions>
                <v-icon color="#FFFFFF"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-4">
                <portal-loading :show="dload"></portal-loading>
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete :label="$t('message.doc.type', { value: 'default' })"
                    :items="$t('message.doctypes', { value: 'default' })" item-value="key" item-text="value" multiple
                    v-model="ptypes" outlined dense>
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0">{{ item.value }}</span>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ ptypes.length - 1 }} )
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="12" sm="3" md="2">
                  <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field :label="$t('message.page.startDate', { value: 'default' })" readonly
                        :value="startDateDisp" v-on="on" :rules="requiredRules" outlined dense></v-text-field>
                    </template>
                    <v-date-picker v-model="startDateVal" no-title @input="startDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="d-flex" cols="12" sm="3" md="2">
                  <v-menu v-model="endDateMenu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field :label="$t('message.page.endDate', { value: 'default' })" readonly
                        :value="endDateDisp" :rules="requiredRules" v-on="on" outlined dense></v-text-field>
                    </template>
                    <v-date-picker v-model="endDateVal" no-title @input="endDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="d-flex" cols="12" sm="2" md="2">
                  <v-btn color="#00475A" dark @click="filter">{{
                    $t("message.button.submit", { value: "default" })
                  }}</v-btn>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col offset-md="8"><v-text-field v-model="search" append-icon="mdi-magnify"
                    :label="$t('message.search', { value: 'default' })" single-line hide-details></v-text-field></v-col>
              </v-row>
              <v-data-table :headers="headers" :items="edls" :search="search" class="elevation-0 mt-4"
                :loading="loading" :loading-text="$t('message.loadingText', { value: 'default' })">
                <template v-slot:[`item.document_date`]="{ item }">
                  {{ formatedDate(item.document_date) }}
                </template>
                <template v-slot:[`item.type[0]`]="{ item }">
                  {{ filterDocType(item.type[0]) }}
                </template>
                <template v-slot:[`item.document`]="{ item }">
                  {{ item.reference[0] }}
                  <v-icon @click="download(item)"> mdi-download</v-icon>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>


      </div>

      <!-- certif dialog -->
      <v-dialog v-model="certDialog" max-width="900">
        <v-card>
          <v-card-title class="text-h5 mb-5">
            <v-icon color="#00475A">mdi-certificate</v-icon>
            {{ currentCertificate?.asset }} {{ $t(getCertifiteType(currentCertificate?.type)) }}
          </v-card-title>

          <v-card-text>

            <v-sheet outlined rounded class="pa-4">
              <h3 class="mb-4">
                <v-icon color="#00475A">mdi-file</v-icon>
                {{ $t("message.doc.certificat.genralInfo", { value: "default" }) }}
              </h3>
              <div>
                <p>
                  <span>{{ $t("message.doc.certificat.asOf", { value: "default" }) }} </span>
                  <b>{{ getCertificateDate(currentCertificate) }} </b>
                  <span> {{ $t("message.doc.certificat.andAccording", { value: "default" }) }}
                    {{ $t("message.doc.certificat.contractRes", { value: "default" }) }}
                    <b>{{ currentCertificate?.agreement }}</b> </span>
                  <br>
                  <span v-if="isDelevry(currentCertificate?.type)">
                    {{ $t("message.doc.certificat.representBy", { value: "default" }) }}
                    {{ $t("message.doc.certificat.delivryTo", { value: "default" }) }}
                    <b> {{ currentCertificate?.customerName }} </b>
                  </span>
                  <span v-else>
                    {{ $t("message.doc.certificat.society", { value: "default" }) }}
                    <b> {{ currentCertificate?.customerName }} </b>
                    {{ $t("message.doc.certificat.delivryToAkm", { value: "default" }) }}
                  </span>
                  <span>{{ $t("message.doc.certificat.locomotive", { value: "default" }) }} </span>
                  <b>{{ currentCertificate?.asset }}</b>
                  <span> UIC number </span> <b>{{ currentCertificate?.immatriculation }}</b>


                  <span v-if="isDelevry(currentCertificate?.type)">
                    {{ $t("message.doc.certificat.delivryAt", { value: "default" }) }}
                  </span>
                  <span v-else>
                    {{ $t("message.doc.certificat.redelivryAt", { value: "default" }) }}
                  </span>
                  <span> <b> {{ currentCertificate?.appointmentLocation }} </b></span>
                </p>
                <p>
                  <span>{{ $t("message.doc.certificat.restDerog", { value: "default" }) }} : </span>
                  <b>{{ currentCertificate?.derog }}</b>
                </p>
                <p>
                  <span>{{ $t("message.doc.certificat.comment", { value: "default" }) }} : </span>
                  <b>{{ currentCertificate?.comment }}</b>
                </p>
                <p>
                  <span>{{ $t("message.doc.certificat.edl", { value: "default" }) }} : </span>
                  <b v-if="currentCertificate?.edlAttached">{{ $t("message.doc.certificat.yes", { value: "default" })
                  }}</b>
                  <b v-else>{{ $t("message.doc.certificat.no", { value: "default" }) }}</b>
                </p>

                <p><span>{{ $t("message.doc.certificat.remark", { value: "default" }) }} : </span>
                  {{ $t("message.doc.certificat.rem1", { value: "default" }) }}</p>


                <p>
                  <b>{{ $t("message.doc.certificat.rem2", { value: "default" }) }}</b>
                </p>


              </div>

            </v-sheet>
            <v-sheet outlined rounded class="pa-4 mt-4">
              <h3 class="mb-4">
                <v-icon color="#00475A">mdi-clipboard-pulse</v-icon>
                {{ $t("message.doc.certificat.technicalInfo", { value: "default" }) }}
              </h3>
              <div>
                <span>Km {{ currentCertificate?.metertype }} </span>
                <span> <b>{{ currentCertificate?.meterReading }}</b> </span>
                <span> {{ $t("message.doc.certificat.date", { value: "default" }) }} </span>
                <span><b>{{ formatedDate(currentCertificate?.meterDate) }}</b></span>
                <br>
                <span>{{ $t("message.doc.certificat.hmMoteur", { value: "default" }) }}: </span>
                <span><b>{{ currentCertificate?.hmReading }}</b> </span>
                <span> {{ $t("message.doc.certificat.date", { value: "default" }) }} </span>
                <span> <b>{{ formatedDate(currentCertificate?.hmDate) }}</b> </span>
                <br>
                <span>{{ $t("message.doc.certificat.wheelset", { value: "default" }) }} : {{
                  $t("message.doc.certificat.lastRecord", { value: "default" }) }} </span>
                <span> <b>{{ formatedDate(currentCertificate?.wheelsetDate) }}</b> </span>

                <v-row>
                  <v-col class="text-center d-flex justify-center">
                    <v-sheet width="300" class="mx-3 mt-3">

                      <div class="d-flex flex-column wheel">
                        <!-- wheel measure right -->
                        <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left">
                              R:{{ currentCertificate?.wheelsetMeasurements[0]?.rightValue }}
                            </v-col>
                            <v-col class="schema-text text-right">
                              R:{{ currentCertificate?.wheelsetMeasurements[1]?.rightValue }}
                            </v-col>
                          </v-row>
                        </v-card>
                        <!--wheel nums-->
                        <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left pl-7">
                              <b>{{ currentCertificate?.wheelsetMeasurements[0]?.wheelsetNumber }}</b>
                            </v-col>
                            <v-col class="schema-text">
                              <b>{{ currentCertificate?.wheelsetMeasurements[1]?.wheelsetNumber }}</b>
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- wheel measure left -->
                        <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left">
                              L:{{ currentCertificate?.wheelsetMeasurements[0]?.leftValue }}
                            </v-col>
                            <v-col class="schema-text text-right">
                              L:{{ currentCertificate?.wheelsetMeasurements[1]?.leftValue }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </div>

                      <img src="@/assets/wheels.png" height="150" alt="logo" style="display: block; margin: auto; " />

                    </v-sheet>
                  </v-col>
                  <v-col class="text-center d-flex justify-center">
                    <v-sheet width="300" class="mx-3 mt-3">

                      <div class="d-flex flex-column wheel">
                        <!-- wheel measure right -->
                        <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left">
                              R:{{ currentCertificate?.wheelsetMeasurements[2]?.rightValue }}
                            </v-col>
                            <v-col class="schema-text text-right">
                              R:{{ currentCertificate?.wheelsetMeasurements[3]?.rightValue }}
                            </v-col>
                          </v-row>
                        </v-card>
                        <!--wheel nums-->
                        <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left pl-7">
                              <b>{{ currentCertificate?.wheelsetMeasurements[2]?.wheelsetNumber }}</b>
                            </v-col>
                            <v-col class="schema-text">
                              <b>{{ currentCertificate?.wheelsetMeasurements[3]?.wheelsetNumber }}</b>
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- wheel measure left -->
                        <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                          <v-row>
                            <v-col class="schema-text text-left">
                              L:{{ currentCertificate?.wheelsetMeasurements[2]?.leftValue }}
                            </v-col>
                            <v-col class="schema-text text-right">
                              L:{{ currentCertificate?.wheelsetMeasurements[3]?.leftValue }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </div>

                      <img src="@/assets/wheels.png" height="150" alt="logo" style="display: block; margin: auto; " />

                    </v-sheet>
                  </v-col>
                </v-row>
                <v-row>
                  <span><i>**{{ $t("message.doc.certificat.defaultMes", { value: "default" }) }}</i></span>
                  <br>
                </v-row>


              </div>
            </v-sheet>
            <v-sheet outlined rounded class="pa-4 mt-4">
              <h3 class="mb-4">
                <v-icon color="#00475A">mdi-signature</v-icon>
                {{ $t("message.doc.certificat.signature", { value: "default" }) }}
              </h3>
              <v-row>
                <v-col>
                  <h4>{{ signature.name }}</h4>
                  <h5>{{ formatedDate(currentCertificate?.signatureDate) }}</h5>
                  <img :src="signature.link" :alt="signature.name" width="150">
                </v-col>
                <v-col>
                  <v-row class="my-4 d-flex flex-row-reverse" v-if="currentCertificate?.status == 1">
                    <v-btn color="#00475A" outlined @click="showRejectPopup = true" class=" ml-3">
                      {{ $t("message.doc.certificat.reserv", { value: "default" }) }}
                    </v-btn>

                    <v-btn color="#00475A" outlined @click="showValidationPopup = true">

                      {{ $t("message.extrawork.confirm", { value: "default" }) }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>


            </v-sheet>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- validation dialogs-->
      <v-dialog v-model="showValidationPopup" width="600" overlay-color="#fff" overlay-opacity="0.5">
        <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
          <v-system-bar height="30" color="#fff" class="px-0 mb-3">
            <span></span>
            <v-spacer></v-spacer>
            <v-icon size="32" class="pt-5" @click="showValidationPopup = false">mdi-close</v-icon>
          </v-system-bar>

          <v-card outlined elevation="0" style="border: none">
            <v-card-title>
              <h4 class="message"> Confirmez vous la validation du document ?</h4>
            </v-card-title>
            <v-card-text class="pt-1">
              <v-row class="px-1 mb-1">

                <div class="valid-popup-buttons">
                  <v-btn color="#6E85A2" dark @click="showValidationPopup = false" class="mr-3">
                    {{ $t("message.button.cancel", { value: "default" }) }}
                  </v-btn>
                  <v-btn color="#6E85A2" dark @click="doCertificate(true)">
                    {{ $t("message.button.submit", { value: "default" }) }}
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showRejectPopup" width="650" overlay-color="#fff" overlay-opacity="0.5">
        <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
          <v-system-bar height="30" color="#fff" class="px-0 mb-3">
            <span></span>
            <v-spacer></v-spacer>
            <v-icon size="32" class="pt-5" @click="showRejectPopup = false">mdi-close</v-icon>
          </v-system-bar>

          <v-card outlined elevation="0" style="border: none">
            <v-card-title>
              <h4 class="message">
                <span>Vous emmetez une ou plusieurs reserves ?</span><br>
                <span>Dites nous lesquelles :</span>
              </h4>
            </v-card-title>
            <v-card-text class="pt-1">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>

                  <v-textarea ref="reason" outlined dense color="#00475A" v-model="reason"
                    placeholder="rejection reason" :rules="rules"></v-textarea>
                </v-row>
                <v-row class="px-1 mb-1">

                  <div class="valid-popup-buttons">
                    <v-btn color="#6E85A2" dark @click="showRejectPopup = false" class="ml-3 mr-3">
                      {{ $t("message.extrawork.cancel", { value: "default" }) }}
                    </v-btn>
                    <v-btn color="#6E85A2" dark @click="doCertificate(false)">
                      {{ $t("message.extrawork.confirm", { value: "default" }) }}
                    </v-btn>
                  </div>
                </v-row>
              </v-form>

            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>

      <!-- info dialogs-->
      <v-dialog v-model="infoDial" width="350" overlay-color="#fff" overlay-opacity="0.5" closable>
        <v-alert border="bottom" colored-border :type="dialType" elevation="2">
          {{ dialInfo }}
        </v-alert>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalLoading from "@/components/PortalLoading.vue";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import CoreService from "../services/CoreService";
import { getDocType } from "@/shared/Helper"
import {
  formatMagicDate,
  addMonthToDate,
  formatInfoDate,
  getMomentDate,
} from "@/shared/DateHelper";
import { mapGetters, mapActions } from "vuex";

export default {
  title: "My documents",
  watch: {
    getterCurrentClient() {
      this.getCertificate();
      this.initEdl();
    },

    infoDial(val) {
      if (!val) return

      setTimeout(() => (this.infoDial = false), 1000)
    },
  },
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalLoading,
  },
  data() {
    return {
      rules: [
        value => !!value || 'Required.',
        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
      valid: false,
      panel: 0,
      dialType: "",
      dialInfo: "",
      signature: {
        name: "Sebastien RODRIGUEZ",
        link: "seb.jpg"
      },
      infoDial: false,
      showRejectPopup: false,
      showValidationPopup: false,
      edls: [],
      dates: [],
      ptypes: [],
      payload: {},
      reason: "",
      loading: false,
      cloading: false,
      currentCertificate: null,
      certificates: [],
      certificatesToValidate: [],
      rejectCertificate: [],
      confirmCertificate: [],
      dload: false,
      search: "",
      menu: false,
      endDateVal: null,
      endDateMenu: false,
      startDateVal: null,
      startDateMenu: false,
      certDialog: false,
      requiredRules: [(value) => !!value || "this firld is required"],
    };
  },
  methods: {
    ...mapActions("customer", {
      loadFleet: "loadFleet",
      loadLocos: "loadLocos",
    }),

    isDelevry(type) {
      if (type == "LIVRAISON") {
        return true
      }
      return false
    },

    showInfo(type, message) {
      if (type) {
        this.dialType = "success"
        this.dialInfo = "Success"
      } else {
        this.dialType = "error"
        this.dialInfo = message
      }
      this.infoDial = true
    },

    async doCertificate(action) {
      if (!action) {
        await this.$refs.form.validate()

        if (!this.valid) {
          return
        }
      }
      CoreService.doCertificateValidation({
        user: this.getterUser.mail,
        action: action,
        comment: this.reason,
        certificat: this.currentCertificate.id
      }).then(() => {
        this.reason = ""
        if (action) {
          this.showValidationPopup = false
        } else {
          this.showRejectPopup = false
        }
        this.certDialog = false
        this.getCertificate()
        this.showInfo(true, "")

      }).catch((err) => {
        this.showInfo(false, err.response.data)
      });

    },

    getCertifiteType(type) {
      return getDocType(type)
    },


    show(item) {
      this.currentCertificate = item
      this.certDialog = true
    },

    getCertificateDate(certificat) {
      return formatInfoDate(certificat?.type == "LIVRAISON" ? certificat?.lesingStartDate : certificat?.lesingEndDate,
        this.$i18n.locale)
    },

    fromBinary(encoded) {
      return window.atob(encoded);
    },

    getCertificate() {
      this.cloading = true
      CoreService.findCertificate(this.getterCurrentClient).then(
        (response) => {
          this.certificates = response.data
          this.certificatesToValidate = this.certificates.filter((c) => c.status == 1)
          this.rejectCertificate = this.certificates.filter((c) => c.status == 2)
          this.confirmCertificate = this.certificates.filter((c) => c.status == 3)
          this.cloading = false
        }
      ).catch(() => {
        this.certificates = []
        this.certificatesToValidate = []
        this.rejectCertificate = []
        this.confirmCertificate = []
        this.cloading = false
      })
    },

    download(item) {
      this.dload = true;
      CoreService.download(item.dochandle).then((response) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers["content-type"],
          })
        );
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", item.reference[0]);
        document.body.appendChild(fileLink);

        fileLink.click();
        this.dload = false;
      });
    },

    getUrl(item) {
      CoreService.download(item.dochandle).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", item.reference[0]);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

    getTypesForPayload() {
      this.payload.type = [];
      for (var i = 0; i < this.ptypes.length; i++) {
        this.payload.type = this.payload.type.concat(this.ptypes[i].split(","));
      }
    },

    filterDocType(type) {
      switch (type) {
        case "PRIMA DELIVERY CERTIFICATE":
          return this.$t("message.doc.certificat.delivry", {
            value: "default",
          });
        case "TRAXX DELIVERY CERTIFICATE":
          return this.$t("message.doc.certificat.delivry", {
            value: "default",
          });
        case "DELIVERY (EXCEPT NEW)":
          return this.$t("message.doc.edl.delivry", { value: "default" });
        case "REDELIVERY":
          return this.$t("message.doc.edl.redelivry", { value: "default" });
        case "RESTITUTION":
          return this.$t("message.doc.edl.redelivry", { value: "default" });
        default:
          return type;
      }
    },




    formatedDate(date) {
      if (date == "") {
        return "";
      }

      if (date == undefined) {
        return "";
      }

      if (date == null) {
        return "";
      }
      return formatMagicDate(date);
    },

    filter() {
      this.payload.periode_debut = this.startDateVal;
      this.payload.type_doc = [
        process.env.VUE_APP_EDL,
        process.env.VUE_APP_CERT,
      ];
      this.getTypesForPayload();
      this.payload.periode_fin = this.endDateVal;
      this.payload.customer_code = [this.getterCurrentClient];
      this.getEdl(this.payload);
    },

    initEdl() {
      this.payload.periode_debut = addMonthToDate(-12);
      this.payload.type_doc = [
        process.env.VUE_APP_EDL,
        process.env.VUE_APP_CERT,
      ];
      this.payload.periode_fin = getMomentDate();
      this.payload.customer_code = [this.getterCurrentClient];
      this.getEdl(this.payload);
    },

    getEdl(payload) {
      this.loading = true;
      CoreService.getDocs(payload)
        .then((response) => {
          this.edls = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.edls = [];
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterUser: "getUserContact"
    }),
    ...mapGetters("customer", {
      getterFleet: "getFleat",
      getterLocos: "getFilterLoc",
    }),

    dateRangeText() {
      return this.dates.join(" ~ ");
    },

    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
    headers() {
      return [
        {
          text: this.$t("message.page.loconumber", { value: "default" }),
          align: "start",
          sortable: true,
          value: "locomotive_number[0]",
        },
        {
          text: this.$t("message.page.doctype", { value: "default" }),
          sortable: true,
          value: "type[0]",
        },
        {
          text: this.$t("message.pageKm.date", { value: "default" }),
          sortable: true,
          value: "document_date",
        },
        {
          text: this.$t("message.magic.action", { value: "default" }),
          sortable: true,
          value: "document",
        },
      ];
    },

    ccheaders() {
      return [
        {
          text: this.$t("message.page.loconumber", { value: "default" }),
          align: "start",
          sortable: true,
          value: "asset",
        },
        {
          text: this.$t("message.page.doctype", { value: "default" }),
          sortable: true,
          value: "type",
        },
        {
          text: this.$t("message.pageKm.date", { value: "default" }),
          sortable: true,
          value: "leasingStartDate",
        },
        {
          text: this.$t("message.magic.action", { value: "default" }),
          sortable: true,
          value: "id",
        },
      ];
    },
  },
  mounted() {
    this.initEdl();
    this.getCertificate();
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.display-wheel {
  display: flex !important;
  justify-content: flex-start;
  align-items: baseline;
}


.v-btn--disabled {
  color: blue;
}

.schema-text {
  font-size: 10px;
}

.wheel {
  position: absolute;
  height: 150px;
  width: 300px;
}
</style>